import type { BlockCreate, BlockCreateInput, QuizBody } from '@/types/blocks'

// Поле ввода варианта держит пробел в конце (иначе второе слово не набрать), но на
// бэк он не должен уезжать: «Да » и «Да» — разные ответы у сверки с ответом ученика.
// Обрезаем на границе api, рядом с normalizeButtons, — формам про это помнить не нужно.
const trimBody = <B extends QuizBody | null>(body: B): B =>
  body
    ? {
        ...body,
        answers: body.answers.map((a) => ({ ...a, text: a.text === null ? null : a.text.trim() })),
      }
    : body

export const trimQuizAnswers = <T extends BlockCreate | BlockCreateInput>(body: T): T =>
  body.type === 'quiz'
    ? { ...body, body: trimBody(body.body), bodyEn: trimBody(body.bodyEn) }
    : body
